export const featuresData = [
  {
    id: 1,
    icon: "Package",
    title: "Control de Inventario Inteligente",
    description: "Gestión automática de stock con alertas de reabastecimiento, códigos de barras y seguimiento en tiempo real."
  },
  {
    id: 2,
    icon: "ShoppingCart",
    title: "Sistema POS Avanzado",
    description: "Terminal de ventas completo con múltiples métodos de pago, facturación electrónica y gestión de clientes."
  },
  {
    id: 3,
    icon: "BarChart3",
    title: "Análisis y Reportes",
    description: "Dashboards interactivos, reportes personalizables y análisis predictivo para tomar mejores decisiones."
  },
  {
    id: 4,
    icon: "Users",
    title: "Gestión Multi-usuario",
    description: "Control de acceso por roles, seguimiento de actividades y gestión completa de empleados."
  },
  {
    id: 5,
    icon: "Smartphone",
    title: "App Móvil",
    description: "Accede a tu inventario desde cualquier lugar con nuestra aplicación móvil nativa para iOS y Android."
  },
  {
    id: 6,
    icon: "Cloud",
    title: "Backup en la Nube",
    description: "Sincronización automática, backups seguros y acceso desde múltiples dispositivos y ubicaciones."
  }
];

export const benefitsData = [
  {
    id: 1,
    title: "Ahorro de Tiempo",
    description: "Reduce hasta 70% el tiempo dedicado a tareas administrativas",
    percentage: "70%",
    color: "blue"
  },
  {
    id: 2,
    title: "Reducción de Errores",
    description: "Minimiza errores humanos en un 95% con automatización inteligente",
    percentage: "95%",
    color: "green"
  },
  {
    id: 3,
    title: "Aumento de Ventas",
    description: "Incrementa tus ventas promedio en un 35% con mejor gestión",
    percentage: "35%",
    color: "purple"
  },
  {
    id: 4,
    title: "Control de Costos",
    description: "Reduce costos operativos hasta en un 45% optimizando procesos",
    percentage: "45%",
    color: "orange"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "María González",
    position: "Gerente General",
    company: "Supermercado El Ahorro",
    avatar: "https://images.unsplash.com/photo-1494790108755-2616c-c63c6d6c6d?w=150",
    rating: 5,
    text: "SAIP transformó completamente nuestra operación. La gestión de inventario ahora es automática y nunca nos quedamos sin productos clave. El ROI fue evidente en el primer mes."
  },
  {
    id: 2,
    name: "Carlos Mendoza",
    position: "Propietario",
    company: "Farmacia San Rafael",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150",
    rating: 5,
    text: "La facilidad de uso es increíble. Mis empleados se adaptaron en una semana y ahora nuestros procesos de venta son mucho más rápidos y eficientes."
  },
  {
    id: 3,
    name: "Ana Rodríguez",
    position: "Directora de Operaciones",
    company: "Distribuidora Norte",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150",
    rating: 5,
    text: "El soporte técnico de RESET es excepcional. Siempre están disponibles y resuelven cualquier consulta al instante. La inversión valió cada peso."
  }
];

export const pricingData = [
  {
    id: 1,
    name: "SAIP Starter",
    price: "99",
    period: "mes",
    description: "Perfecto para pequeños negocios que inician",
    features: [
      "Hasta 1,000 productos",
      "1 usuario administrador",
      "POS básico",
      "Reportes básicos",
      "Soporte por email",
      "Backup diario"
    ],
    popular: false,
    color: "gray"
  },
  {
    id: 2,
    name: "SAIP Professional",
    price: "199",
    period: "mes",
    description: "La solución completa para empresas en crecimiento",
    features: [
      "Productos ilimitados",
      "5 usuarios incluidos",
      "POS avanzado + App móvil",
      "Reportes avanzados + Analytics",
      "Soporte 24/7",
      "Backup en tiempo real",
      "Integración con contabilidad",
      "Códigos de barras"
    ],
    popular: true,
    color: "blue"
  },
  {
    id: 3,
    name: "SAIP Enterprise",
    price: "399",
    period: "mes",
    description: "Solución empresarial para grandes organizaciones",
    features: [
      "Todo de Professional",
      "Usuarios ilimitados",
      "Multi-sucursales",
      "IA y análisis predictivo",
      "API personalizada",
      "Implementación dedicada",
      "Capacitación presencial",
      "SLA garantizado 99.9%"
    ],
    popular: false,
    color: "purple"
  }
];

export const faqData = [
  {
    id: 1,
    question: "¿Qué tan difícil es implementar SAIP?",
    answer: "SAIP está diseñado para ser implementado en menos de 24 horas. Nuestro equipo técnico se encarga de toda la configuración inicial y migración de datos. Incluimos capacitación completa para tu equipo."
  },
  {
    id: 2,
    question: "¿Funciona sin conexión a internet?",
    answer: "Sí, SAIP funciona completamente offline. Los datos se sincronizan automáticamente cuando se restablece la conexión, garantizando que nunca pierdas una venta."
  },
  {
    id: 3,
    question: "¿Puedo migrar mis datos actuales?",
    answer: "Absolutamente. Nuestro equipo migra todos tus datos existentes (productos, clientes, historial de ventas) sin costo adicional. El proceso es completamente transparente."
  },
  {
    id: 4,
    question: "¿Qué tipo de soporte ofrecen?",
    answer: "Ofrecemos soporte 24/7 por chat, teléfono y email. También incluimos capacitación inicial, documentación completa y actualizaciones automáticas sin costo adicional."
  },
  {
    id: 5,
    question: "¿Es seguro para mis datos empresariales?",
    answer: "La seguridad es nuestra prioridad. Utilizamos encriptación de nivel bancario, backups automáticos múltiples y cumplimos con todas las normativas de protección de datos."
  }
];

export const dashboardStats = {
  sales: {
    daily: 15420,
    weekly: 89650,
    monthly: 342180,
    growth: "+12.5%"
  },
  products: {
    total: 2547,
    lowStock: 18,
    outOfStock: 3,
    newThisMonth: 127
  },
  customers: {
    total: 1893,
    newThisMonth: 156,
    returning: 78.2,
    satisfaction: 4.8
  },
  performance: {
    uptime: "99.9%",
    responseTime: "1.2s",
    transactions: "15.8k",
    efficiency: "+47%"
  }
};